import Vue from "vue";

import moment from "moment";
import "moment/locale/zh-cn";

import _ from "lodash";

import VueHighcharts from "vue-highcharts";
import HighCharts from "highcharts";
import HighStock from "highcharts/highstock";
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import histogram from "highcharts/modules/histogram-bellcurve";
import annotations from "highcharts/modules/annotations";
import boost from "highcharts/modules/boost";
// import exportCSV from "@/utils/plugins/exportcsv";
import loadHeatmap from "@/utils/heatmap.js";
loadHeatmap(HighCharts);
Vue.use(VueHighcharts);
import axios from "axios";

import Antd from "ant-design-vue";
import { message, Modal } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import nVue from "n-vue";
import packageConfig from "../../package.json";

import {
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Tree,
  DatePicker,
  Input,
  Upload,
  Image
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Tree);
Vue.use(DatePicker);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Image);

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$_ = _;
Vue.prototype.$HighCharts = HighCharts;
window.Highcharts = HighCharts;
Vue.use(Antd);
// highcharts, moment 基本设置
moment.locale("zh-cn");
exporting(HighCharts);
exportData(HighCharts);
histogram(HighCharts);
annotations(Highcharts);
boost(HighCharts);
// exportCSV(HighCharts);
exporting(HighStock);
exportData(HighStock);

let exportOptions = {
  global: {
    useUTC: false
  },
  // fixed Chinese lang options
  lang: {
    printChart: "打印图表",
    downloadJPEG: "下载 JPEG 文件",
    downloadPDF: "下载 PDF&nbsp;&nbsp; 文件",
    downloadPNG: "下载 PNG&nbsp; 文件",
    downloadSVG: "下载 SVG&nbsp; 文件",
    downloadCSV: "下载 CSV&nbsp; 文件",
    downloadXLS: "下载 XLS&nbsp;&nbsp; 文件",
    viewData: "查看数据表格"
  },
  exporting: {
    filename: "数据",
    buttons: {
      contextButton: {
        menuItems: [
          "printChart",
          "separator",
          "downloadXLS",
          "downloadCSV",
          "downloadJPEG",
          "downloadPNG",
          "downloadSVG"
        ]
      }
    },
    csv: {
      dateFormat: "%Y-%m-%d %H:%M:%S"
    }
  }
};

HighCharts.setOptions(exportOptions);
HighStock.setOptions(exportOptions);

Vue.use(nMap);
Vue.use(nMapGD);
Vue.use(nVue);

Vue.prototype.$sr = colorIntensity.sensortypeRound;
Vue.prototype.$logout = nVue.logout;
